import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AttachmentPreviewModalComponent } from '../components/modals/attachment-preview-modal/attachment-preview-modal.component';
import { FULLSCREEN_PREVIEW_MODAL_CONFIG } from './fullscreen-preview-modal.config';

export interface AttachmentPreviewConfig {
  fileId: number;
  fileName: string;
  applicationId?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AttachmentPreviewManager {

  constructor(private modalService: NzModalService) { }

  /**
   * Open attachment preview modal
   */
  openPreview(config: AttachmentPreviewConfig): void {
    const modalRef = this.modalService.create({
      ...FULLSCREEN_PREVIEW_MODAL_CONFIG,
      nzContent: AttachmentPreviewModalComponent,
      nzWrapClassName: 'attachment-preview-modal-wrapper'
    });

    // Set input parameters after modal is created
    const componentInstance = modalRef.getContentComponent();
    componentInstance.fileId = config.fileId;
    componentInstance.fileName = config.fileName;
    componentInstance.applicationId = config.applicationId!;
  }
}
